import React, { forwardRef, useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
  Typography,
  Button,
  Icon,
  Grid,
} from '@mui/material'
import { motion } from 'framer-motion'
import { AccountBalance, Close, Link, LinkOff, Sync } from '@mui/icons-material'

import { useQuilttIntegration } from 'hooks/useQuilttIntegration'
import { QuilttButton, testtest } from '@quiltt/react'
import { AnimatePresence } from 'framer-motion'
import { NewBalanceSheetModalForm } from 'layouts/authenticated/pages/newdash/components/NewBalanceSheetModalForm'
import { QuilttLogo } from 'components/QuilttLogo'
import { format } from 'date-fns'
import { useModal } from 'components/modals'
import { useFinances } from 'hooks/useFinances'
import { useIntake } from 'hooks/useIntakeContext'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})
const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export default function EditAccount({
  accountType = 'Account',
  isAdmin = false,
  account,
  onClose,
  getAccounts = () => {
    console.log('')
  },
  closeModal = () => {
    console.log('')
  },
}) {
  const [page, setPage] = useState(
    Object.prototype.hasOwnProperty.call(account, 'externalAsset') ? 1 : 0
  )
  const [direction, setDirection] = useState(1)

  const [type, setType] = useState()
  const [subType, setSubType] = useState()
  const [amount, setAmount] = useState()
  const [name, setName] = useState()

  const [open, setOpen] = useState(false)
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [plaidName, setPlaidName] = useState()
  const [sortKey, setSortKey] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [frequency, setFrequency] = useState()
  const [ieStartDate, setIeStartDate] = useState()
  const [policyNumber, setPolicyNumber] = useState()
  const [balance, setBalance] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [issueDate, setIssueDate] = useState()
  const [anniversaryDate, setAnniversaryDate] = useState()
  const [keepInRetirement, setKeepInRetirement] = useState()
  const [carrier, setCarrier] = useState()
  const [product, setProduct] = useState()
  const [signalLinked, setSignalLinked] = useState()
  const [linkedAccountId, setLinkedAccountId] = useState()
  const { createOrUpdateAccount } = useFinances()
  const { unlinkQuilttConnection } = useQuilttIntegration()

  const { openModal } = useModal()

  const { intakeState } = useIntake()

  const syncQuiltt = () => {
    console.log('Sync Quiltt Starter')
  }

  useEffect(() => {
    if (account) {
      console.log(account)
      setType(account.type || '')
      setSubType(account.subType || '')
      setAmount(account.amount || 0)
      setName(account.name || '')
      setId(account.id || '')
      setVersion(account._version || '')
      setPlaidName(account.plaidName || '')
      setSortKey(account.typeSubTypeUuid || '')
      setSubTypeClassification(account.subTypeClassification || '')
      setInterestRate(account.interestRate || '')
      setMonthlyPayment(account.monthlyPayment || '')
      setFrequency(account.frequency || '')
      setKeepInRetirement(account.keepInRetirement || '')
      setLoanEndDate(account.loanEndDate || '')
      setIeStartDate(account.ieStartDate || '')
      setPolicyNumber(account.policyNumber || '')
      setBalance(account.balance || '')
      setIssueDate(account.issueDate || '')
      setAnniversaryDate(account.anniversaryDate || '')
      setCarrier(account.carrier || '')
      setProduct(account.product || '')
      setSignalLinked(account.signalLinked || '')
      setLinkedAccountId(account.linkedAccountId || '')
    }
  }, [account])

  const handleClose = () => {
    setOpen(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setSubTypeClassification('')
    setInterestRate('')
    setMonthlyPayment('')
    setLoanEndDate('')
    setIeStartDate('')
    setPolicyNumber('')
    setKeepInRetirement('')
    setBalance('')
    setIssueDate('')
    setCarrier('')
    setProduct('')
    setAnniversaryDate('')
    setSignalLinked('')
    setLinkedAccountId('')
    onClose()
  }

  const handleReload = () => {
    getAccounts()
    handleClose()
  }

  const unlinkAndCreate = async () => {
    const subTypeSwap =
      subType !== ''
        ? subType
        : account.externalType === 'CREDIT'
        ? 'creditcard'
        : 'other'
    await createOrUpdateAccount({
      name,
      amount,
      type,
      subType: subTypeSwap,
      subTypeClassification,
      interestRate,
      loanEndDate,
      monthlyPayment,
      keepInRetirement,
      frequency,
      ieStartDate,
      policyNumber,
      balance,
      issueDate,
      anniversaryDate,
      carrier,
      product,
      signalLinked,
      linkedAccountId,
    })
    openModal('fallbackModal', {
      title: 'Unlink Complete!',
      content: (
        <>
          Your account <strong>{account.name}</strong> has been unlinked.
        </>
      ),
      showAction: false,
    })
    await unlinkQuilttConnection({
      sessionToken: intakeState?.quilttSessionToken,
      connectionId: account.externalConnectionId,
    })
    getAccounts()
    handleClose()
  }

  const handleExitSuccess = (metadata) => {
    getAccounts()
    openModal('fallbackModal', {
      title: 'Re-Sync Complete!',
      content: (
        <>
          Your account <strong>{account.name}</strong> has been re-synced.
        </>
      ),
      showAction: false,
    })
  }

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0,
    }),
  }

  const pages = [
    <Box key="1" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          {accountType} Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 1, md: 3 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Edit the information below:
        </Typography>
      </Box>

      <NewBalanceSheetModalForm
        // handleClose={handleClose}
        canEdit={true}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        keepInRetirement={keepInRetirement}
        setKeepInRetirement={setKeepInRetirement}
        frequency={frequency}
        setFrequency={setFrequency}
        ieStartDate={ieStartDate}
        setIeStartDate={setIeStartDate}
        setPolicyNumber={setPolicyNumber}
        policyNumber={policyNumber}
        setBalance={setBalance}
        balance={balance}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        issueDate={issueDate}
        setIssueDate={setIssueDate}
        carrier={carrier}
        setCarrier={setCarrier}
        product={product}
        setProduct={setProduct}
        anniversaryDate={anniversaryDate}
        setAnniversaryDate={setAnniversaryDate}
        signalLinked={signalLinked}
        setSignalLinked={setSignalLinked}
        linkedAccountId={linkedAccountId}
        setLinkedAccountId={setLinkedAccountId}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={open}
        handleSubmit={handleClose}
        reloadAccounts={handleReload}
        newStyle={true}
        isAdmin={isAdmin}
        handleClose={onClose}
      />
    </Box>,
    <Box key="2" sx={{ padding: { xs: 1, md: 6, lg: 6 } }}>
      <Box sx={{}}>
        <Typography variant={'headerTitle'} color={'#262627'}>
          Linked Account Details
        </Typography>
      </Box>
      <Box sx={{ marginY: { xs: 1, md: 4 } }}>
        <Typography variant={'body1'} color={'#495057'}>
          Your account below has been linked. Your balance is automatically
          refreshed every time you sign in!
        </Typography>
      </Box>
      <Box display="flex" gap="16px" alignItems="center">
        <Box sx={{ width: '50px', height: '50px' }}>
          {account?.externalInstitutionLogo ? (
            <img
              style={{
                objectFit: 'fill',
                border: '1px solid #f1f1f1',
                borderRadius: '50px',
                width: '50px',
                height: '50px',
              }}
              src={account.externalInstitutionLogo}
              alt=""
            />
          ) : (
            <Box
              sx={{
                border: '1px solid #f1f1f1',
                borderRadius: '50px',
                width: '50px',
                height: '50px',
                '&>svg': {
                  height: '36px',
                  width: '36px',
                  margin: '7px',
                },
              }}
            >
              <AccountBalance />
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',

            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#495057',
                fontSize: { xs: '18px', md: '24px' },
                fontWeight: 600,
                lineHeight: 1.33,
                textTransform: 'uppercase',
              }}
            >
              {account.externalInstitutionName}
            </Typography>
            <Typography
              sx={{
                color: '#495057',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              {account.externalName}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: { xs: 1, md: 0 },
              alignSelf: { xs: 'flex-start', md: 'center' },
              flexShrink: 0,
              padding: '6px 24px',
              background: '#F5EBFE',
              borderRadius: '32px',
            }}
          >
            <Box
              sx={{
                alignItems: 'flex-start',
                justifyContent: 'flex-start',

                // display: 'inline-block',
                display: 'flex',
                flexDirection: 'column',
                '&>svg': { marginBottom: '-2px', marginRight: '8px' },
              }}
            >
              <QuilttLogo />
              <Typography
                sx={{
                  display: 'inline-block',
                  color: '#8351F8',
                  fontSize: '18px',
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
              >
                Account Linked
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box mt={3}>
        <Typography
          sx={{
            color: '#495057',
            fontSize: '18px',
            fontWeight: 600,
            lineHeight: 1.5,
          }}
        >
          Account Balance
        </Typography>
        <Box
          mt={1}
          sx={{
            background: '#F5EBFE',
            border: '2px solid #8F62F8',
            padding: '10px 14px',
            borderRadius: '8px',
          }}
        >
          <Typography
            sx={{
              color: '#8F62F8',
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: 1.5,
            }}
          >
            {`${dollarFormat.format(amount)} - Linked Balance`}
          </Typography>
        </Box>
        <Box
          mt={1}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#8F62F8',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: 1.5,
              display: 'flex',
              alignItems: 'center',
              '& svg': { marginRight: '8px' },
            }}
          >
            <Link />
            Updated {format(new Date(account.updatedAt), 'MM/dd/yyyy')}
          </Typography>
          <Box display="flex">
            <Box
              component={QuilttButton}
              connectorId="5ugr9q35ag"
              connectionId={account.externalConnectionId}
              onExitSuccess={handleExitSuccess}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: '4px 8px', md: '8px 16px' },
                backgroundColor: '#FFF',
                border: '2px solid #8F62F8',
                color: '#8F62F8',
                boxShadow: 'none',
                borderRadius: '100px',
                textTransform: 'capitalize',
                fontWeight: 600,
                fontSize: { xs: '12px', md: '16px' },
                lineHeight: 1.5,
                letterSpacing: '0.32px',
                display: 'flex',
                cursor: 'pointer',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#F5EBFE',
                  border: '2px solid #8F62F8',
                  boxShadow: 'none',
                },
                '&:disabled': {
                  borderColor: 'rgba(0,0,0,0)',
                },
                '& svg': {
                  fontSize: { xs: '18px !important', md: '24px !important' },
                },
              }}
            >
              <Sync />
              Sync Account
            </Box>
            <Button
              variant="contained"
              onClick={() => {
                openModal('fallbackModal', {
                  title: 'Unlink this account?',
                  content: (
                    <>
                      Your account <strong>{account.name}</strong> will no
                      longer receive automatic updates.
                    </>
                  ),
                  buttonText: 'Unlink Account',
                  buttonColor: '#FF2F32',
                  buttonHoverColor: '#cc2528',
                  cancelButtonText: 'Keep it Linked',
                  actionOverride: unlinkAndCreate,
                })
              }}
              // disabled={}
              startIcon={<LinkOff />}
              sx={{
                marginLeft: '16px',
                padding: '8px 16px',
                backgroundColor: '#FFF',
                border: '2px solid #FF2F32',
                color: '#FF2F32',
                boxShadow: 'none',
                borderRadius: '100px',
                textTransform: 'capitalize',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: 1.5,
                letterSpacing: '0.32px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#ffeaea',
                  border: '2px solid #FF2F32',
                  boxShadow: 'none',
                },
                '&:disabled': {
                  borderColor: 'rgba(0,0,0,0)',
                },
                '& svg': {
                  fontSize: '24px !important',
                },
              }}
            >
              Unlink
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>,
  ]

  // console.log(account)

  return (
    <>
      <Dialog
        open
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'md'}
        PaperProps={{
          sx: {
            overflow: { xs: 'auto', sm: 'visible' },
            margin: '16px',
            width: 'calc(100% - 32px)',
            marginTop: 'max(15vh, 58px)',
            alignSelf: 'flex-start',
            marginBottom: '64px',
          },
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            top: { xs: 8, sm: -48 },
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
          <DialogContent
            sx={{ overflow: 'visible', paddingTop: { xs: '40px', sm: '16px' } }}
          >
            <motion.div
              key="accounts"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <AnimatePresence mode="wait" custom={direction}>
                <motion.div
                  key={page}
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.3 }}
                  style={{
                    position: 'relative',
                    width: '100%',
                  }}
                >
                  {pages[page]}
                </motion.div>
              </AnimatePresence>
            </motion.div>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  )
}
